import { type ReactNode } from 'react'
import styles from './QuestionEditorCompactItem.module.css'
import {
  QuestionTitle,
  QuestionDescription,
} from '@/features/jobs/questions/components/QuestionContent'
import { useToggle } from '@/hooks/state-hooks'

export interface QuestionEditorCompactItemProps {
  title: string
  description: string
  validationErrors: readonly string[]
  children?: ReactNode
}

export function QuestionEditorCompactItem({
  title,
  description,
  validationErrors,
  children,
}: QuestionEditorCompactItemProps) {
  const showingDescToggle = useToggle(false)
  return (
    <div className={styles.root}>
      <div className={styles.details}>
        <div title={`${title}\n-------\n${description}`}>
          <QuestionTitle
            compact
            title={title}
            onToggleInfo={description ? showingDescToggle.toggle : undefined}
          />
          <QuestionDescription
            description={description}
            hidden={!showingDescToggle.isEnabled}
          />
        </div>
        <div className={styles.editor}>{children}</div>
        {validationErrors.length > 0 && (
          <div className={styles.errors}>{validationErrors.join(' / ')}</div>
        )}
      </div>
    </div>
  )
}
